import { CoObjectItem } from "../components/interfaces/CoObject";
import { createContentControlForCoObject } from "./ContentControl";
import { getContentControlById } from "./WordDocumentPart";

/* global Word */

export function insertCheckbox(coObject: CoObjectItem) {
  return Word.run(async (context) => {
    const ccId = await createContentControlForCoObject(coObject);
    const wordContentControl = await getContentControlById(context, ccId);

    const checkboxOOXML =
      '<pkg:package xmlns:pkg="http://schemas.microsoft.com/office/2006/xmlPackage"> <pkg:part pkg:name="/_rels/.rels" pkg:contentType="application/vnd.openxmlformats-package.relationships+xml"> <pkg:xmlData> <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"> <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml"/> </Relationships> </pkg:xmlData> </pkg:part> <pkg:part pkg:name="/word/document.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"> <pkg:xmlData> <w:document xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml"> <w:body> <w:p> <w:pPr/> <w:sdt> <w:sdtPr> <w:rPr/> <w14:checkbox> <w14:checked w14:val="0"/> <w14:checkedState w14:val="2612" /> <w14:uncheckedState w14:val="2610" /> </w14:checkbox> </w:sdtPr> <w:sdtContent> <w:r> <w:rPr /> <w:t>☐</w:t> </w:r> </w:sdtContent> </w:sdt> </w:p> </w:body> </w:document> </pkg:xmlData> </pkg:part> </pkg:package>';

    wordContentControl.insertOoxml(checkboxOOXML, Word.InsertLocation.start);
    await context.sync();

    return wordContentControl.id;
  });
}
